import { AppBar, Container, Toolbar, Button } from '@mui/material'
import { Terminal as TerminalIcon, History as HistoryIcon, PowerSettingsNew as PowerIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const CommandNav = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <AppBar position="sticky" elevation={0} sx={(theme) => ({ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, top: 0, mb: 0, borderBottom: `1px solid ${theme.palette.divider}` })}>
      <Container maxWidth="xl" disableGutters>
        <Toolbar disableGutters variant="dense">
          <Button
            color="inherit"
            startIcon={<TerminalIcon />}
            onClick={() => navigate('/command/functions')}
            sx={{ ml: 2 }}
          >
            {t('command.title', 'Functions')}
          </Button>
          <Button
            color="inherit"
            startIcon={<PowerIcon />}
            onClick={() => navigate('/command/disabled')}
            sx={{ ml: 2 }}
          >
            {t('command.disabled.title', 'Disabled')}
          </Button>
          <Button
            color="inherit"
            startIcon={<HistoryIcon />}
            onClick={() => navigate('/command/audit')}
            sx={{ ml: 2 }}
          >
            {t('command.audit.title', 'Audit')}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default CommandNav
